import { createReducer } from 'helpers/ReducerUtil'
import { combineReducers } from 'redux'

import {
    UPDATE_ACTIVE_PRODUCT_FAMILY_DIALOG,
    UPDATE_INACTIVE_PRODUCT_FAMILY_DIALOG,
    CHANGE_PARTNER_SITE_SEARCH_QUERY,
    UPDATE_PRODUCT_FAMILY_PARTNER_SITE_LIST,
    UPDATE_SELECTED_PARTNER_SITE,
    UPDATE_PRODUCT_FAMILY_LIST,
    UPDATE_SELECTED_PRODUCT_FAMILY,
    CLEAR_PARTNER_SITE,
    CLEAR_PRODUCT_FAMILY_SELECTION,
    UPDATE_PRODUCT_FAMILY_PARTNER_SITE_TABLE_LIST,
    CLEAR_PRODUCT_FAMILY_PARTNER_SITE_TABLE_LIST,
    UPDATE_CURRENT_PAGE,
    CLEAR,
    SET_ACTIVE_PFPS_DIALOG,
    SET_INACTIVE_PFPS_DIALOG,
    CHANGE_SEARCH_VALUE,
    ROW_OPTIONS,
    UPDATE_COUNT_SIZE,
    UPDATE_PAGE_SIZE,
    UPDATE_SELECT_PFPS,
    UPDATE_PFPS_ROLES,
    UPDATE_SELECTED_PRODUCT_FAMILY_FROM_PFPS,
    UPDATE_SELECTED_PARTNER_SITE_FROM_PFPS,
} from './constants'

const updateActiveAddDialog = (prev, { active }) => {
    return active
}

const updatePartnerSiteQuery = (prev, { query }) => {
    return query
}

const updatePartnerSiteList = (prev, { list }) => {
    if (list) {
        return list
    } else {
        return []
    }
}

const updateSelectedPartnerSite = (prev, { value }) => {
    return value
}

const updateProductFamilyList = (prev, { list }) => {
    if (list) {
        return list
    } else {
        return []
    }
}

const updateSelectedProductFamily = (prev, { value }) => {
    return value
}

const updateTable = (prev, { list }) => list

const clearPartnerSite = ( prev ) => null

const clearProductFamilySelection = ( prev ) => null

const updateCurrentPage = (prev, { page }) => page

const updateSearchValue = (prev, { value }) => value

const updatePageSize = (prev, { size }) => size
const updateCountSize = (prev, { count }) => count
const updateSelectedPfps = (prev, { id }) => id

const updatePfpsRoles = (prev, { roles }) => roles

const activeAddDialogReducer = createReducer(false, {
    [UPDATE_ACTIVE_PRODUCT_FAMILY_DIALOG]: updateActiveAddDialog,
    [UPDATE_INACTIVE_PRODUCT_FAMILY_DIALOG]: updateActiveAddDialog
})

const partnerSiteQueryReducer = createReducer('', {
    [CHANGE_PARTNER_SITE_SEARCH_QUERY]: updatePartnerSiteQuery
})

const partnerSiteListReducer = createReducer([], {
    [UPDATE_PRODUCT_FAMILY_PARTNER_SITE_LIST]: updatePartnerSiteList
})

const selectedPartnerSiteReducer = createReducer({}, {
    [UPDATE_SELECTED_PARTNER_SITE]: updateSelectedPartnerSite,
    [UPDATE_SELECTED_PARTNER_SITE_FROM_PFPS]: updateSelectedPartnerSite,
    [CLEAR_PARTNER_SITE]: clearPartnerSite
})

const productFamilyListReducer = createReducer([], {
    [UPDATE_PRODUCT_FAMILY_LIST]: updateProductFamilyList,
})

const selectedProductFamilyReducer = createReducer('', {
    [UPDATE_SELECTED_PRODUCT_FAMILY]: updateSelectedProductFamily,
    [UPDATE_SELECTED_PRODUCT_FAMILY_FROM_PFPS]: updateSelectedProductFamily,
    [CLEAR_PRODUCT_FAMILY_SELECTION]: clearProductFamilySelection
})

const productFamilyPartnerSiteTableList = createReducer([], {
    [UPDATE_PRODUCT_FAMILY_PARTNER_SITE_TABLE_LIST]: updateTable,
    [CLEAR_PRODUCT_FAMILY_PARTNER_SITE_TABLE_LIST]: () => []
})

const currentPageSliceReducer = createReducer(1, {
    [CLEAR]: () => 1,
    [UPDATE_CURRENT_PAGE]: updateCurrentPage
})

const selectedPfpsReducer = createReducer('', {
    [UPDATE_SELECT_PFPS]: updateSelectedPfps
})

const activePfpsDialogReducer = createReducer(false, {
    [SET_ACTIVE_PFPS_DIALOG]: () => true,
    [SET_INACTIVE_PFPS_DIALOG]: () => false 
})

const searchValueReducer = createReducer('', {
    [CHANGE_SEARCH_VALUE]: updateSearchValue
})

const countSizeSliceReducer = createReducer(0, {
    [CLEAR]: () => 0,
    [UPDATE_COUNT_SIZE]: updateCountSize
})

const pageSizeSliceReducer = createReducer(ROW_OPTIONS[10], {
    [CLEAR]: () => ROW_OPTIONS[10],
    [UPDATE_PAGE_SIZE]: updatePageSize
})

const pfpsRolesReducer = createReducer([], {
    [UPDATE_PFPS_ROLES]: updatePfpsRoles
})

export default combineReducers({
    activeAdd: activeAddDialogReducer,
    partnerSiteQuery: partnerSiteQueryReducer,
    partnerSiteList: partnerSiteListReducer,
    selectedPartnerSite: selectedPartnerSiteReducer,
    productFamilyList: productFamilyListReducer,
    selectedProductFamily: selectedProductFamilyReducer,
    productFamilyPartnerSiteTableList: productFamilyPartnerSiteTableList,
    selectedPfps: selectedPfpsReducer,
    activePfpsDialog: activePfpsDialogReducer,
    searchValue: searchValueReducer,
    
    count: countSizeSliceReducer,
    currentPage: currentPageSliceReducer,
    pageSize: pageSizeSliceReducer,
    pfpsRoles: pfpsRolesReducer
})
  